async function postEmail(email, message) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/emails`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          data: {
            email,
            message,
          },
        }),
      },
    );
    return response.json();
  } catch (error) {
    throw new Error(error.message);
  }
}

export default postEmail;
